// Types
import { RootState } from 'types/RootState.types';

export const getCardTypeNameSelector = (state: RootState) => state.cardType?.name;
